<ems-confirm-message #confirmationMessage></ems-confirm-message>

<tr-review-security-type #reviewSecurityType [selectedValues]="multiLevelSecurityType" [formData]="reviewRuleData"></tr-review-security-type>
<div class="review-heading sdps-p-bottom_small">{{emtrConst.ruleSteps.step4.reviewRule}}</div>

<div class="review-rules">
  <form [formGroup]="reviewRuleForm" *ngIf="reviewRuleForm">
    <!-- Display Rule Name and selected Rule Type -->
    <div class="sdps-p-bottom_large select-rule-type step-border-box">
      <div class="sdps-grid-container sdps-wrap">
        <div class="col-5 sdps-p-top_large sdps-p-left_none">
          <div class="rule-type-textbox"
               [ngClass]="{'invalidField': (reviewRuleForm.get('reviewRuleName').value && reviewRuleForm.get('reviewRuleName').invalid), 'input-disabled': (reviewRuleData.status === 'EXPIRED' ||  !showActionItems || !showActionItemForGRule || sharedService.showHistoricalView.value || !shouldShowEditIcon())}">
                        <p-floatlabel variant="in">
                            <input type="text" id="reviewRuleName" name="ruleName" [maxlength]=100 formControlName="reviewRuleName"
                                   (ngModelChange)="editRuleNameDescriptionNotes()" emsCharacterLimit
                                   value="reviewRuleForm.get('reviewRuleName').value" emsAlphaNumericSpecialCharacterValidation
                                   [charMaxLimit]="commonConstants.charLimitValues.hundredMaxLimit"
                                   (emsCharacterLimitCheck)="showCharLimit = $event"
                                   pInputText/>
                            <label for="reviewRuleName">
                              {{emtrConst.rulesConstant.ruleName}}
                              <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
                            </label>
                        </p-floatlabel>
          </div>
          <p class="sdps-text-right sdps-m-around_none sdps-text-small line-height-nml"
             *ngIf="reviewRuleForm.get('reviewRuleName').value.trim().length > showCharLimit">{{emtrConst.rulesConstant.characterLimit}}
            <span
              class="character-limit">{{reviewRuleForm.get('reviewRuleName').value.trim().length}}/{{commonConstants.charLimitValues.hundredMaxLimit}}</span>
          </p>
        </div>
        <div [ngClass]="(reviewRuleData.ruleSubCategory === emtrConst.rule10b5Msg.label10b5Txt) ? 'col-2' : 'col-2'">
          <div class="sdps-p-top_x-large sdps-p-left_x-large">{{emtrConst.rulesConstant.ruleType}}</div>
          <div class="sdps-p-left_x-large sdps-text-l-bold-body">
            <span>{{(rulesCategory === 'RESTRICT_LST_ENG') ? reviewRuleData.isSuperRestriction === 'Y'? emtrConst.rulesConstant.ruleGlobalConst.superRestriction : emtrConst.rulesConstant.ruleGlobalConst.restriction : (rulesCategory === 'Override') ? emtrConst.rulesConstant.ruleGlobalConst.override: emtrConst.rulesConstant.ruleGlobalConst.watchList}}</span>
          </div>
        </div>

        <div class="col-2">
          <div *ngIf="isPlanIdVisible || isSpecialBlackoutVisible || reviewRuleData.ruleSubCategory === sharedConstant.openBrokerage.subType">
            <div class="sdps-p-top_x-large sdps-p-left_x-large">{{emtrConst.rule10b5Msg.restrictionCategoryTxt}}</div>
            <div class="sdps-p-left_x-large sdps-text-l-bold-body">
              <span>{{restrictionCategoryLabel}}</span>
            </div>
          </div>
        </div>
        <div class="col-2">
          <div  *ngIf="isPlanIdVisible">
          <div class="sdps-p-top_x-large sdps-p-left_x-large">{{emtrConst.rule10b5Msg.planIdTxt}}</div>
          <div class="sdps-p-left_x-large sdps-text-l-bold-body">
            <span>{{reviewRuleData.planId}}</span>
          </div>
        </div>
        </div>

        <div class="sdps-p-top_x-large sdps-pull-right col-1 sdps-p-right_none" *ngIf="reviewRuleData.status !== 'EXPIRED'">

          <button type="button" *ngIf="shouldShowEditIcon()"
                  class="sdps-pull-right sdps-button sdps-button--secondary sdps-is-selected disabled-edit-button"
                  [attr.aria-label]="emtrConst.ruleSteps.step4.ruleTypeTooltip"
                  disabled>
            <em class="pi pi-pencil" aria-hidden="true" pTooltip="{{emtrConst.ruleSteps.step4.ruleTypeTooltip}}"
                tooltipPosition="left"></em>
          </button>
        </div>
      </div>
    </div>

    <!-- Display selected Justification for Override -->
    <ems-accordion [label]="emtrConst.rulesConstant.ruleGlobalConst.justification" class="disabled-button-icon"
                   [disabledButton]="true"
                   [editable]="shouldShowEditIcon()"
                   [toolTip]="true" [message]="overrideTooltip" [showEditIcon]="reviewRuleData.status"
                   *ngIf="reviewRuleData.override === 'Y'">
      <div class="emtr-radio sdps-grid-container sdps-p-left_large sdps-m-around_none sdps-p-vertical_small select-rule-type"
           *ngIf="reviewRuleData.override === 'Y'">
        <div class="sdps-m-around_none sdps-p-left_small sdps-p-top_medium" *ngFor="let justification of sharedConstant[businessUnit].overrideJustification">
          <div class="col-2">
            <p-radioButton class="col-2 sdps-p-top_small radio-button" name="justification" [value]=justification [label]="justification" formControlName="justification"
                         (ngModelChange)="editRuleNameDescriptionNotes()"></p-radioButton>
            <label class="sdps-p-left_x-small" [innerHTML]="justification"></label>
          </div>
        </div>
        <span class="p-float-label rule-type-textbox sdps-p-around_small col-4 other-input"
              [ngClass]="((reviewRuleForm.get('justification').value !== 'Other' || reviewRuleData.status ==='EXPIRED' || !showActionItems || !showActionItemForGRule  || sharedService.showHistoricalView.value) ? 'input-disabled' : 'input-enabled')">
            <input type="text" name="others" maxlength="35" formControlName="otherInput" aria-label="Other justification"
                   (ngModelChange)="editRuleNameDescriptionNotes()" pInputText #step4_otherInput/>
          </span>
      </div>
    </ems-accordion>

    <!-- Display selected Rule Attributes -->
    <ems-accordion
      [label]="emtrConst.rulesConstant.ruleTypeLabels.ruleAttributes"
      [editable]="shouldShowEditIcon()" (editPanel)="goToPreviousStep('../step2')" [disabledButton]="!(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))"
      [ngClass]="{'disabled-button-icon' : !(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))}" [showEditIcon]="reviewRuleData.status">

      <p class="sdps-p-horizontal_xx-large no-margin"
         [innerHTML]="(reviewRuleData.ruleType === emtrConst.rulesConstant.autoComplete.FNDISUTxt) ? emtrConst.rulesConstant.ruleTypeLabels[rulesCategory]+ ' ' + emtrConst.rulesConstant.ruleTypeLabels.ruleTypeFundFamilyTitle : emtrConst.rulesConstant.ruleTypeLabels[rulesCategory]+ ' ' + emtrConst.rulesConstant.ruleTypeLabels.ruleTypeTitle"></p>

      <tr-restrict-checkbox class="emtr-checkbox-disable" [rulesCategory]="rulesCategory" [ruleType]="reviewRuleData.ruleType"
                            [restrictForm]="reviewRuleForm.get('restrictForm')"></tr-restrict-checkbox>
    </ems-accordion>

    <!--Display rule subtype IND SEC-->
    <ems-accordion [label]="subTypeLabel" [editable]="shouldShowEditIcon()"
                   (editPanel)="goToPreviousStep('../step2')" *ngIf='reviewRuleData.ruleType !== "SECTYP"'
                   [disabledButton]="!(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))"
                   [ngClass]="{'disabled-button-icon' : !(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))}"
                   [showEditIcon]="reviewRuleData.status">
      <div *ngIf='reviewRuleData.ruleType !== emtrConst.rulesConstant.autoComplete.FNDISUTxt'>
        <div class="sdps-p-top_small sdps-p-bottom_xx-small sdps-p-horizontal_xx-large sdps-text-l-bold-body">
          <span [innerHTML]="emtrConst.rulesConstant.appliesTo"></span>
          <span class="sdps-text-market-red" [innerHTML]="commonConstants.asterix"></span>
        </div>

        <!--Display Applies To-->
        <div class="sdps-p-horizontal_xx-large sdps-p-bottom_small">
          <p-checkbox class="emtr-checkbox emtr-checkbox-disable" *ngIf="appliesTo === 'BTH' || appliesTo === 'IND'"
                      binary="true"
                      formControlName="indSecs" label="{{emtrConst.rulesConstant.individualSecurity}}"></p-checkbox>
                      <label  *ngIf="appliesTo === 'BTH' || appliesTo === 'IND'" class="sdps-p-left_x-small">{{emtrConst.rulesConstant.individualSecurity}}</label>
          <span *ngIf="appliesTo === 'BTH'">&nbsp;&nbsp;</span>
          <p-checkbox *ngIf="appliesTo === 'BTH' || appliesTo === 'OPT' || appliesTo === 'DV'" class="emtr-checkbox emtr-checkbox-disable"
                      binary="true"
                      formControlName="underlyingOpts"></p-checkbox>
                      <label *ngIf="appliesTo === 'BTH' || appliesTo === 'OPT' || appliesTo === 'DV'" class="sdps-p-left_x-small">{{( defaultBusinessUnit === sharedConstant.rbsBUText || defaultBusinessUnit === '' ) ? emtrConst.rulesConstant.underlyingDerivatives : emtrConst.rulesConstant.underlyingOptions}}</label>
        </div>

        <!--Display Security Type -->
        <div class="sdps-p-top_small sdps-p-bottom_xx-small sdps-p-horizontal_xx-large sdps-text-l-bold-body" *ngIf="reviewRuleData.securityType.length > 0">
          {{emtrConst.rulesConstant.securityType}}
        </div>
        <span class="sdps-flex sdps-p-horizontal_xx-large">
        <div class="sdps-p-bottom_small sdps-p-right_x-small"  *ngFor="let security of securityType;let i = index">
          <p-checkbox class="emtr-checkbox emtr-checkbox-disable" 
          [(ngModel)]="security.selected"
            [ngModelOptions]="{standalone: true}" binary="true" disabled></p-checkbox>
                      <label class="sdps-p-left_x-small sdps-p-right_x-small">{{security.code}}</label>
        </div>
        </span>
      </div>

      <!-- Display selected Securities -->
      <ems-table-record-count [count]="indSecs && indSecs.length" [showRecords]="indSecs && indSecs.length && indSecs.length > sharedConstant.defaultTableRecords"
                              (emitter)="indTable.reset();receiveDataFromChild($event, 'indSecs')"
                              [showHeaderIcons]="false"></ems-table-record-count>
      <p-table [columns]="securityTableHeader" [value]="indSecs" [paginator]="(indSecs && indSecs.length && indSecs.length > sharedConstant.defaultTableRecords) ? true : false" [rows]="noOfRecordsIndSecs" #indTable
               class="common-data-table" [ngClass]="{ 'display-inline-block mb-35': indSecs && indSecs.length && indSecs.length <= sharedConstant.defaultTableRecords}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns">{{col.header}}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="sdps-text-center"
                [innerHTML]="emtrConst.rulesConstant.autoComplete.noSecuritySelected"></td>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-indSec let-columns="columns">
          <tr>
            <td *ngFor="let col of columns">
              <span *ngIf="col.field === 'name'">{{indSec[col.field] | titlecase}}</span>
              <span *ngIf="col.field !== 'name'">{{indSec[col.field]}}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Display selected Instruments Groups -->
    <div
    *ngIf="reviewRuleData.ruleType === 'INDSEC' && rulesCategory !== emtrConst.rulesConstant.ruleTypeLabels.WATCH_LST_ENGText && (this.viewIG || sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.instrumentsSummary.uuid, '', ''))">
    <ems-table-record-count [count]="instGroup && instGroup.length" [showRecords]="instGroup && instGroup.length && instGroup.length > sharedConstant.defaultTableRecords"
      (emitter)="indTable.reset();receiveDataFromChild($event, 'instGroup')" [showHeaderIcons]="false"></ems-table-record-count>
    <p-table [columns]="instGrpTableHeader" [value]="instGroup" [paginator]="(instGroup && instGroup.length && instGroup.length > sharedConstant.defaultTableRecords) ? true : false" [rows]="noOfRecordsInstGroup" #indTable
      class="common-data-table" [ngClass]="{ 'mb-35': instGroup && instGroup.length && instGroup.length <= 15}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="sdps-text-center"
            [innerHTML]="emtrConst.rulesConstant.autoComplete.noInstrumentGroupSelected"></td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-instGrp let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <span *ngIf="col.field !== 'tickerSymbols'" [title]="instGrp[col.field]">{{instGrp[col.field]}}</span>
            <span *ngIf="col.field === 'tickerSymbols'">
              <button type="button" class="btn-text-link ruleGrpLinks" (click)="child.openModal(instGrp)"
                      [title]="emtrConst.rulesConstant.ruleGlobalConst.viewSymboleInstGrpText"
                      [attr.aria-label]="emtrConst.rulesConstant.ruleGlobalConst.viewSymboleInstGrpText"
                      [innerHTML]="emtrConst.rulesConstant.ruleGlobalConst.viewSymboleInstGrpText"></button>
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
      <tr-view-symbols-modal #child></tr-view-symbols-modal>
    </ems-accordion>

    <!--Display Rule subType Securtity Data-->
    <ems-accordion [label]="subTypeLabel" *ngIf='reviewRuleData.ruleType === "SECTYP"' [editable]="shouldShowEditIcon()"
                   (editPanel)="goToPreviousStep('../step2')" [disabledButton]="!(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))"
                   [ngClass]="{'disabled-button-icon' : !(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))}"
                   [showEditIcon]="reviewRuleData.status">
      <div *ngIf="sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.ruleSummary.uuid, '', '')">
      <div class="security-type-holder">
        <div class="security-selected-result">
          <div class="sdps-p-top_medium sdps-datepicker__range" *ngFor='let item of multiLevelUpdatedList | keyvalue '>
            <div class="security-type-text" [ngClass]="{'security-restrict-icon': reviewRuleData?.override !== 'Y'}">
              @if (reviewRuleData?.override !== 'Y') {
                <sdps-icon class="security-delete-icon" [attr.sdps-id]="item.key + '_restrictedIcon'" sdps-aria-label="Restricted" type="functional" name="delete" size="small" color="error"></sdps-icon>
              } @else {
                <span class="sch-check-circle security-highlight"></span>
              }
              <span class="sdps-p-left_medium security-level-text">{{item.key}}</span>
            </div>
            <div class="whole-container">
              <div *ngFor="let first of item.value | slice:0;">
                                <span *ngIf="first.data.level === 'SC1'">Level 1 {{first.data.desc}}
                                  ({{first.data.code}})
                                    <span *ngIf="first.data.selected">({{first.data.selected}})</span>
                                </span>
                <span *ngIf="first.data.level === 'SC2'">Level 2 {{first.data.desc}} ({{first.data.code}})
                                    <span *ngIf="first.data.selected">({{first.data.selected}})</span>
                                </span>
                <span *ngIf="first.data.level === 'SC3'">Level 3 {{first.data.desc}} ({{first.data.code}})
                                    <span *ngIf="first.data.selected">({{first.data.selected}})</span>
                                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- Review Security Type button Section - for Asset group or Miscellaneous asset grp selection -->
      <div *ngIf="displaySelectedAssetGrp && displaySelectedAssetGrp.length > 0 && !(displaySelectedAssetGrp.length === 1 && displaySelectedAssetGrp[0].code === emtrConst.ruleSteps.step2.digitalAssetGroupCode)" class="security-type-holder">
        <button type="button" class="choose-security-box" (click)="openSecurityType($event)">
          <div class="security-box-content pi pi-list" aria-hidden="true"></div>
          <span class="sdps-p-left_x-small">{{emtrConst.presetRules.reviewSecTypeDetailsText}}</span>
        </button>
      </div>

      <!-- Preset Rules and Asset Groups Section -->
      <div
        *ngIf="reviewRuleData.rulesCategory !== emtrConst.rulesConstant.ruleTypeLabels.WATCH_LST_ENGText && (!reviewRuleData.micAGSelectedFlag)">
        <div class="security-type-holder">
          <div class="security-selected-result">
            <div class="sdps-p-top_medium sdps-p-bottom_medium sdps-datepicker__range" *ngFor='let item of displaySelectedAssetGrp'>
              <span class="security-type-text" [ngClass]="{'security-restrict-icon': reviewRuleData?.override !== 'Y'}">
                <!-- assetGroupCheckboxClass is computed once here and reused below to avoid
                     recomputing getAssetGroupCheckboxClass/getTotalAttributeCount per row. -->
                @if(ruleService.getAssetGroupCheckboxClass(item, businessUnit, ruleService.getTotalAttributeCount(item['code'])); as assetGroupCheckboxClass) {
                  @if (assetGroupCheckboxClass === 'sch-check-circle' && reviewRuleData?.override !== 'Y') {
                     <sdps-icon class="security-delete-icon" [attr.sdps-id]="item['code'] + '_assetGroupRestrictedIcon'" sdps-aria-label="Restricted" type="functional" name="delete" size="small" color="error"></sdps-icon>
                  } @else {
                  <span id="{{item['code']}}_assetGroupCheckbox" class="assetGroup-highlight" [ngClass]="assetGroupCheckboxClass"></span>
                  }
                }
                <span id="{{item['code']}}_assetGroupLabel" class="sdps-p-left_medium security-level-text">{{item['name']}}</span>
              </span>
              <div class="whole-container display-flex">
                <div *ngFor="let first of item['attributes']" [ngClass]="{'security-restrict-icon': reviewRuleData.override !== 'Y'}">
                  @if (reviewRuleData.override !== 'Y') {
                    <sdps-icon class="security-delete-icon sdps-p-right_medium" [attr.sdps-id]="item['code'] + '_attributeRestrictedIcon'" sdps-aria-label="Restricted" type="functional" name="delete" size="small" color="error"></sdps-icon>
                  } @else {
                    <span id="{{item['code']}}_attributeCheckbox" class="sch-check-circle assetGroup-highlight sdps-p-right_medium"></span>
                  }
                  <span id="{{item['code']}}_attributeLabel" class="sdps-p-right_medium">{{first['name']}}</span>
                  <span id="{{emtrConst.ruleSteps.step2.operatingNetExpenseRatio}}" class="sdps-p-right_medium" *ngIf="first['name'] === emtrConst.ruleSteps.step2.operatingNetExpenseRatio">{{first['value']}}</span>
                </div>
               </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Miscellaneous Asset Groups Section -->
      <div
        *ngIf="sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.globalRuleSummary.uuid,'','') && (reviewRuleData.rulesCategory === emtrConst.rulesConstant.autoComplete.RESTRICT_LST_ENGTxt || reviewRuleData.override === 'Y') && (reviewRuleData.micAGSelectedFlag) ">
        <div class="security-type-holder">
          <div class="security-selected-result">
            <div class="sdps-p-top_medium sdps-p-bottom_medium sdps-p-right_x-large sdps-display-inline-block"
                 [ngClass]="{'security-restrict-icon': reviewRuleData.override !== 'Y'}"
                 *ngFor='let item of displaySelectedAssetGrp'>
                 @if (reviewRuleData.override !== 'Y') {
                   <sdps-icon class="security-delete-icon sdps-p-right_medium" [attr.sdps-id]="item['code'] + '_miscAssetGroupRestrictedIcon'" sdps-aria-label="Restricted" type="functional" name="delete" size="small" color="error"></sdps-icon>
                 } @else {
                   <span id="{{item['code']}}_attributeCheckbox" class="sch-check-circle assetGroup-highlight sdps-p-right_medium"></span>
                 }
                <span id="{{item['code']}}_attributeLabel" class="misc-asset-group-color" *ngIf="item.name !== 'Debt'">{{item['name']}}</span>
                <span id="{{item['code']}}_attributeLabel" class="misc-asset-group-color" *ngIf="item.name === 'Debt'">{{item['attributes'][0]['name']}}</span>
            </div>
          </div>
        </div>
      </div>
    </ems-accordion>

    <!-- Display selected From and To Date -->
    <ems-accordion label={{emtrConst.rulesConstant.selectDates}} (editPanel)="goToPreviousStep('../step2')" [editable]="shouldShowEditIcon()"
                   [disabledButton]="!(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))" [ngClass]="{'disabled-button-icon' : !(reviewRuleForm.get('reviewRuleName').value.trim()) || (disableEditIcon && !(disableBtn && disableEditIcon))}"
                   [showEditIcon]="reviewRuleData.status">
      <div class="display-flex emtr-radio select-date">
        <p-radioButton name="selectDate" inputId="selectDate" [ariaLabel]="emtrConst.rulesConstant.selectDates" disabled [(ngModel)]="dateSelectionType"
                       [ngModelOptions]="{standalone: true}" value="date"
                       class="sdps-p-top_small p-radio">
        </p-radioButton>
        <tr-from-to-datepicker
          [calendarForm]="reviewRuleForm.get('calendarForm')"></tr-from-to-datepicker>
      </div>
    </ems-accordion>

    <!-- Display Description and Note -->
    <div class="security-description-container">
      <ems-accordion label={{emtrConst.rulesConstant.descriptionNotesTitle}} [editable]="shouldShowEditIcon()"
                     class="disabled-button-icon"
                     [disabledButton]="true" [toolTip]="true" [message]="toolTipMessage" [showEditIcon]="reviewRuleData.status">
        <tr-description-and-notes class="description-notes" (editTextArea)="editRuleNameDescriptionNotes()"
                                  [descriptionForm]="reviewRuleForm.get('descriptionForm')" [isRuleExpired]="reviewRuleData.status"></tr-description-and-notes>
      </ems-accordion>
    </div>

    <!-- Display selected Participants/Employees, Plans/Emp Group, Master Accounts and Master Groups -->
    <ems-accordion label={{emtrConst.rulesConstant.ruleAssign}} [editable]="shouldShowEditIcon()"
      [ngClass]="{'disabled-button-icon' : !(reviewRuleForm.get('reviewRuleName').value.trim())}"
      [disabledButton]="!(reviewRuleForm.get('reviewRuleName').value.trim())" (editPanel)="goToPreviousStep('../step3')"
      [showEditIcon]="reviewRuleData.status">

      <p-tabs [value]="activeIndex" class="emtr-tab" [selectOnFocus]="true" [lazy]="true">
        <p-tablist>
          <p-tab [value]="0" (click)="activeIndex = 0" [disabled]="disableEmployeeGroupPlan">{{sharedConstant[businessUnit].employeeGrpOrPlan}}</p-tab>
          <p-tab [value]="1" (click)="activeIndex = 1"
            [disabled]="disableEmployeeParticipant || reviewRuleData.ruleSubCategory === sharedConstant.openBrokerage.subType">{{sharedConstant[businessUnit].employeeOrParticipant}}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <!-- Employee Group/Plans/Master Groups tab -->
          <p-tabPanel [value]="0" *ngIf="activeIndex===0">
            <ems-table-record-count [count]="employeeGroups && employeeGroups.length"
              [showRecords]="employeeGroups && employeeGroups.length && employeeGroups.length > 15"
              (emitter)="dt.reset();receiveDataFromChild($event, 'employeeGroups')" [showHeaderIcons]="false">
            </ems-table-record-count>
            <p-table [columns]="employeeGroupTableHeader" [value]="employeeGroups"
              [paginator]="(employeeGroups && employeeGroups.length && employeeGroups.length > 15) ? true : false"
              [rows]="noOfRecordsEmpGroup" [totalRecords]="employeeGroups && employeeGroups.length" #dt
              class="common-data-table">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th scope="col" *ngFor="let col of columns">{{col.header}}</th>
                </tr>
              </ng-template>

              <ng-template #emptymessage let-columns>
                <tr *ngIf="reviewRuleData.global && reviewRuleData.global.type === 'GLOBAL'">
                  <td *ngFor="let col of columns">
                    <span *ngIf="col.field === 'name'"
                      [innerHTML]="emtrConst.ruleSteps.step3.allClientInfo.clientName"></span>
                  </td>
                </tr>
                <tr
                  *ngIf="!reviewRuleData.globalRule || (reviewRuleData.globalRule && reviewRuleData.global && reviewRuleData.global.type === this.emtrConst.rulesConstant.semiGlobalObj.type)">
                  <td [attr.colspan]="columns.length" class="sdps-text-center" [innerHTML]="sharedConstant.noRecords"></td>
                </tr>
              </ng-template>

              <ng-template #body let-employeeGroup>
                <tr>
                  <td>{{employeeGroup.name}}</td>
                  <td>{{employeeGroup.description}}</td>
                  <td *ngIf="businessUnit !== 'RBS' && businessUnit !== 'MGP'">{{employeeGroup.noOfEmployees}}</td>
                  <td>{{employeeGroup.noOfSubAccounts}}</td>
                  <td>{{employeeGroup.noOfRules}}</td>
                  <td [innerHTML]="(employeeGroup.updTs) ? moment(employeeGroup.updTs).format('MM/DD/YYYY') : ''"></td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel [value]="1" *ngIf="activeIndex===1">
            <!-- Table to display Employee/Participants -->
            <div *ngIf="!reviewRuleData.globalRule">
              <ems-table-record-count [count]="" [showRecords]="totalRecords && totalRecords > 15"
                (emitter)="dtt.reset();receiveDataFromChild($event, 'verifyData')" [selectedCount]="" [empIds]=""
                [showHeaderIcons]="false"></ems-table-record-count>
              <p-table [value]="verifyData" [columns]="cols" [rows]="noOfRecordsEmp"
                [totalRecords]="verifyData && verifyData.length" #dtt class="common-data-table">

                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length" class="sdps-text-center" [innerHTML]="sharedConstant.noRecords">
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns; let i = index">
                      <span *ngIf="i === 0 && businessUnit !== 'RBS' &&  rowData[col.field]">{{rowData[col.field]}}</span>
                      <span
                        *ngIf="(i === 0 && businessUnit === 'RBS') || (i === 1 && businessUnit !== 'RBS')">{{rowData[col.field] === '*****' ? rowData[col.field] : (rowData[col.field] | accountNumberFormat)}}</span>
                      <span
                        *ngIf="col.field === 'firstName' || col.field === 'lastName' || col.field === 'acctHolderFn' || col.field === 'acctHolderLn'">{{rowData[col.field]}}</span>
                      <span *ngIf="col.field === 'ruleIds' || col.field === 'groupIds'">{{rowData[col.field] &&
                        rowData[col.field].length}}</span>
                       <span *ngIf="col.field === 'acctHolderName'"> {{accountHolderName(rowData)}}</span>             
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <p-paginator #p [rows]="pageObject.pageSize" [alwaysShow]="(totalRecords && totalRecords > 15) ? true : false"
                [totalRecords]="totalRecords" (onPageChange)="paginate($event)" class="common-pagination"></p-paginator>
            </div>

            <!-- Table to display Master Accounts -->
            <div *ngIf="reviewRuleData.globalRule">
              <ems-table-record-count [count]="" [showRecords]="totalRecords && totalRecords > 15"
                (emitter)="acct.reset();receiveDataFromChild($event, 'verifyData')" [selectedCount]="" [empIds]=""
                [showHeaderIcons]="false"></ems-table-record-count>
              <p-table [value]="verifyData" [columns]="cols" [rows]="noOfRecordsEmp"
                [totalRecords]="verifyData && verifyData.length" #acct class="common-data-table">

                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th scope="col" *ngFor="let col of columns"><span [innerHTML]="col.header"></span></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="columns.length" class="sdps-text-center" [innerHTML]="sharedConstant.noRecords">
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns" [ngClass]="col.field === 'firstName' ? 'word-break' : ''">
                      <span [innerHTML]="rowData[col.field]"></span>
                    </td>
                  </tr>

                </ng-template>
              </p-table>
              <p-paginator #p [rows]="pageObject.pageSize" [alwaysShow]="(totalRecords && totalRecords > 15) ? true : false"
                [totalRecords]="totalRecords" (onPageChange)="paginate($event)" class="common-pagination"></p-paginator>

            </div>
          </p-tabPanel>
        </p-tabpanels>
      </p-tabs>
    </ems-accordion>

    <!-- Display ngOMS Rules Info -->
     <ems-accordion *ngIf="showRulesAssignPanel" label={{sharedConstant.ngOMS.rulesInfo}}>
      <div class="sdps-grid-container sdps-wrap">
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{sharedConstant.ngOMS.ruleId}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleData?.ngOmsRuleInfo?.ruleId}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{sharedConstant.ngOMS.lastSyncStatus}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleData?.ngOmsRuleInfo?.lastSyncStatus?.toUpperCase()}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{sharedConstant.ngOMS.syncStartDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleData?.ngOmsRuleInfo?.syncStartDate}}
            </div>
          </div>
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{sharedConstant.ngOMS.lastSyncDate}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleData?.ngOmsRuleInfo?.lastSyncDate}}
            </div>
          </div>
        </div>
        <div class="sdps-row">
          <div class="col-3">
            <div class="sdps-p-vertical_small">
              <strong>{{sharedConstant.ngOMS.reqCorrelationId}}</strong>
            </div>
            <div class="sdps-grid-container sdps-m-around_none">
              {{reviewRuleData?.ngOmsRuleInfo?.reqCorrelationId}}
            </div>
          </div>
        </div>
      </div>
     </ems-accordion>
  </form>
</div>
<ems-step-wizard-buttons
  [showCancelBtn]="(!(!revertDisable && reviewRuleData.status === 'DRAFT') && !(reviewRuleData.mode === 'Copy' || reviewRuleData.mode ==='' || revertDisable))"
  [showSaveBtn]="reviewRuleData.mode === 'EDIT' && (reviewRuleData.status === 'SCHEDULED' || reviewRuleData.status === 'ACTIVE') && shouldShowEditIcon()"
  [showActivateBtn]="((revertDisable) && !(reviewRuleData.mode === 'EDIT' || reviewRuleData.status === 'SCHEDULED' || reviewRuleData.status === 'ACTIVE'|| reviewRuleData.status === 'EXPIRED') || (reviewRuleData.mode === 'EDIT' && reviewRuleData.status === 'DRAFT'&& revertDisable && shouldShowEditIcon()))"
  [showSaveActivateBtn]="(!revertDisable && !(reviewRuleData.mode === 'EDIT' || reviewRuleData.status === 'SCHEDULED' || reviewRuleData.status === 'ACTIVE') || (!revertDisable && reviewRuleData.mode === 'EDIT' && reviewRuleData.status === 'DRAFT'))"
  [showSaveCloseBtn]="(!revertDisable && !(reviewRuleData.mode === 'EDIT' || reviewRuleData.status === 'SCHEDULED' || reviewRuleData.status === 'ACTIVE') || (!revertDisable && reviewRuleData.mode === 'EDIT' && reviewRuleData.status === 'DRAFT'))"
  [showCloseBtn]="!isFieldEditted && (reviewRuleData.mode === 'Copy' || reviewRuleData.mode === '') || revertDisable"
  [showPreviousBtn]="true && shouldShowEditIcon() && reviewRuleData.status !== 'EXPIRED'" [showRevertBtn]="true && shouldShowEditIcon() && reviewRuleData.status !== 'EXPIRED'"
  [disableBtn]="disableEditIcon || disableBtn || reviewRuleForm.invalid || formObjCompare || (reviewRuleForm.get('reviewRuleName').value && reviewRuleForm.get('reviewRuleName').value.trim().length === 0)" [revertDisable]="revertDisable"
  [disablePrevBtn]="(disableBtn && !(disableBtn && disableEditIcon)) || reviewRuleForm.invalid || (reviewRuleForm.get('reviewRuleName').value && reviewRuleForm.get('reviewRuleName').value.trim().length === 0)"
  (revert)="revertChanges()" (saveAndClose)="ruleSaveAndClose()" (activate)="activateRule($event)"
  (closeBtn)="ruleCancel();navigateTo('/ems/emtr/rules/rules-list')"
  (goToPrevious)="goToPreviousStep('../step3');" (save)="ruleSave($event)"
  [ngomsSyncStatusInfoButtons]="(ngOMSForceSync || downLoadNGOMSRule)"
  [ngOMSForceSync]="ngOMSForceSync && !sharedService.showHistoricalView.value" [downLoadNGOMSRule]="downLoadNGOMSRule  && !sharedService.showHistoricalView.value"
  [forceSyncDisableBtn] = "forceSyncDisableBtn"
  [downloadDisableBtn] = "downloadDisableBtn" [ngOmsDownloadBtnLabel]="sharedConstant.ngOMS.ngOmsRuleDownloadBtnLabel"
  (downloadNgomsRuleAndForceSyncUp)="downloadNgomsRuleAndForceSyncUp($event)"></ems-step-wizard-buttons>